import { createSlice } from '@reduxjs/toolkit';

const initialState = { list: [] };

export const menuListSlice = createSlice({
  name: 'menuList',
  initialState,
  reducers: {
    setMenuList: (state, action) => {
      state.list = action.payload;
    },
  },
});

export const { setMenuList } = menuListSlice.actions;
export default menuListSlice.reducer;
